import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  IconButton,
  Stack,
} from '@mui/material'
import { FC, MouseEvent } from 'react'
import type { FarmQuantificationUnit, ToGeoJSON } from '@/types/apiModels'
import { StratificationQUsAccordionSummary } from './StratificationQUsAccordionSummary'
import { StratificationQUsPaddockUsageTable } from './StratificationQUsPaddockUsageTable'
import { StratificationQUsSOCStrata } from './StratificationQUsSOCStrata'

type StratificationQUsAccordionProps = {
  qu: FarmQuantificationUnit
  samplingAreas: ToGeoJSON[]
  isSamplingAreasVisible: boolean
  onToggleSamplingAreasVisibility: (quId: string) => void
}

export const StratificationQUsAccordion: FC<StratificationQUsAccordionProps> = ({
  qu,
  samplingAreas,
  isSamplingAreasVisible,
  onToggleSamplingAreasVisibility,
}) => {
  const samplingAreasForQU = samplingAreas.filter(
    area => area.properties.quantificationUnitId === qu.id,
  )

  const handleToggleVisibility = (e: MouseEvent) => {
    e.stopPropagation()
    onToggleSamplingAreasVisibility(qu.id)
  }

  return (
    <Accordion
      sx={{
        borderLeft: 4,
        borderLeftStyle: 'solid',
        borderLeftColor: qu.color ?? 'grey.400',
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{ '& .MuiAccordionSummary-content': { alignItems: 'center' } }}
      >
        <StratificationQUsAccordionSummary qu={qu} />
        <IconButton
          aria-label={
            isSamplingAreasVisible ? 'Ocultar áreas de muestreo' : 'Mostrar áreas de muestreo'
          }
          component="span"
          sx={{ ml: 'auto' }}
          onClick={handleToggleVisibility}
        >
          {isSamplingAreasVisible ? <Visibility /> : <VisibilityOff />}
        </IconButton>
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing={2}>
          <StratificationQUsSOCStrata samplingAreas={samplingAreasForQU} />
          <Divider />
          <StratificationQUsPaddockUsageTable qu={qu} />
        </Stack>
      </AccordionDetails>
    </Accordion>
  )
}
